<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! Vamos pensar sobre os comportamentos observados no ambiente de
        trabalho?
      </h2>
    </div>

    <div>
      <h2>
        Aqui você escreve os comportamentos que GOSTA de observar no seu
        ambiente de trabalho.
      </h2>
      <p class="success--text">
        Por exemplo: "Estar sempre disposto a colaborar nas atividades que são
        realizadas na sua unidade."
      </p>
    </div>

    <div>
      <h2>
        Aqui você escreve os comportamentos que NÃO GOSTA de observar no seu
        ambiente de trabalho.
      </h2>
      <p class="error--text">
        Por exemplo: "Estar sempre apresentando dificuldades na realização de
        determinadas tarefas."
      </p>
    </div>

    <div>
      <h2>
        Aqui você escreve os comportamentos IDEAIS para serem observados no seu
        ambiente de trabalho.
      </h2>
      <p class="warning--text">
        Por exemplo: "Procurar aprender e conhecer o trabalho do colega de
        setor."
      </p>
    </div>

    <div>
      <h2>Importante!</h2>
      <ul>
        <li>
          <p class="text-start font-weight-medium info--text text-lg-h6">
            Considere como “ambiente de trabalho” todas as unidades com as quais
            você interage para realizar seu trabalho;
          </p>
        </li>
        <li>
          <p class="text-start font-weight-medium info--text text-lg-h6">
            Não se identifique nem indique de quem é o comportamento nas
            respostas. O sistema coletará todos os dados digitados, mas não
            registrará quem os inseriu;
          </p>
        </li>
        <li>
          <p class="text-start font-weight-medium info--text text-lg-h6">
            Não há limite de descrições de comportamentos a serem registradas;
          </p>
        </li>
        <li>
          <p class="text-start font-weight-medium info--text text-lg-h6">
            Só é necessário registrar a descrição do comportamento observado uma
            única vez, mesmo sendo identificado em duas ou mais pessoas.
          </p>
        </li>
      </ul>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialCadastroComportamental',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução', 'Gosto', 'Não Gosto', 'O Ideal Seria', 'Importante'],
    };
  },
};
</script>
